<template>
  <div>
    <v-toolbar class="primary elevation-0 small-extension" dark>
      <v-btn icon :to="({ name: 'UsuariosLista' })" class="ma-0 white--text">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <h1 class="titulo">Níveis de acesso</h1>
    </v-toolbar>
    <v-list two-line class="pa-0">
      <template v-for="item in roles">
        <v-list-tile v-bind:key="item.id" :to="{ name: 'RolesEditar', params: { id: item.id } }">
          <v-list-tile-content>
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            <v-list-tile-sub-title>
              <span v-if="item.limitado_tarefas">Limitado por tarefas</span>
              <span v-if="item.limitado_proprietario"> | Limitado por proprietário</span>
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
      </template>
    </v-list>
    <v-btn dark fab fixed bottom right class="secondary" :to="({ name: 'RolesAdicionar' })">
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
  import axios from 'axios'
  import { apiURL } from '@/config'

  export default {
    data () {
      return {
        roles: []
      }
    },
    mounted () {
      this.loadRoles()
    },
    methods: {
      loadRoles () {
        this.$store.dispatch('utils/showLoading')
        axios.get(`${apiURL}/roles`).then((response) => {
          this.roles = response.data.data
          this.$store.dispatch('utils/hideLoading')
        }, (error) => {
          const isForbidden = error && error.response && error.response.status === 403
          this.$store.dispatch('utils/showSnackbar', {
            text: isForbidden ? 'Sem permissão para visualizar níveis de acesso.' : 'Erro ao carregar níveis de acesso.'
          })
          this.$store.dispatch('utils/hideLoading')
          if (isForbidden) {
            this.$router.push('/')
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// RolesLista.vue?117eb670